import { Injectable  } from '@angular/core';
import { Component } from '@angular/core';
import Moralis from 'moralis';
import Web3Modal from 'web3modal';
import Web3 from 'web3';
import WalletConnectProvider from "@walletconnect/web3-provider";
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment.prod';
import { Router } from '@angular/router';
import { elderabi } from '../../contracts/prod/elder';
import { dystoabi } from '../../contracts/prod/dysto';
import { stakeabi } from '../../contracts/prod/stake';
import { yygabi } from '../../contracts/prod/yyg';
import { packabi } from '../../contracts/prod/pack';
import { ToastService } from 'angular-toastify';
import { checkAddressChecksum } from 'web3-utils';


//import {environment} from '../../../environments/environment.dev';
@Injectable({
  providedIn: 'root'
})
export class Web3Service {
  provider:any;
  web3:any;
  web3Modal:any;
  wallet:any;
  //chain="goerli";
  //chainId = 6;
  chain="main";
  chainId = 1;
  constructor(private router:Router, private toast:ToastService) {
   
  }

  async initWeb3(){

    const providerOptions = {
      walletconnect: {
        package: WalletConnectProvider, // required
        options: {
          infuraId: "68bbfa6dd6594f328012419c5b654b2f" // required
        }
      }
    };
    
    this.web3Modal = new Web3Modal({
      network: "mainnet", // optional
      cacheProvider: true, // optional
      providerOptions // required
    });

    try {
      this.provider = await this.web3Modal.connect();
      this.web3  = new Web3(this.provider);
      let network = await this.web3.eth.net.getNetworkType();
   

      //Display warning if on the wrong network
      if(network !== this.chain){
        this.toast.info("Please switch to the Ethereum "+ this.chain +" network.");
        await this.web3.currentProvider.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: Web3.utils.toHex(this.chainId) }]
        });
        network = await this.web3.eth.net.getNetworkType();
      
        //return;
      }

      let accounts = await this.web3.eth.getAccounts();
      
      let walletSet = accounts[0];
      this.wallet = walletSet;
      if(!localStorage.getItem('sig')){
        let message = 'This is used to verify that you own this account for the missions dashboard and secures that any actions on the site are made by you alone.';
        let msg = `0x${Buffer.from(message, 'utf8').toString('hex')}`;
        let sig = await this.web3.currentProvider.request({
          method: 'personal_sign',
          params: [msg, walletSet, environment.token]
        });
   
        //console.log(sig)
        localStorage.setItem('sig', sig);
        //let rec = await this.web3.eth.accounts.recover(walletSet,sig);
        //console.log(rec)
      }
      else {
        let message = 'This is used to verify that you own this account for the missions dashboard and secures that any actions on the site are made by you alone.';
        let msg = `0x${Buffer.from(message, 'utf8').toString('hex')}`;
        let rec = await this.web3.eth.accounts.recover(msg,localStorage.getItem('sig'));
        if(rec.toLowerCase() !== walletSet.toLowerCase()){
          let sig = await this.web3.currentProvider.request({
            method: 'personal_sign',
            params: [msg, walletSet, environment.token]
          });
          
          localStorage.setItem('sig', sig);
        }
      }
      let contract = new this.web3.eth.Contract(yygabi, environment.yyg);
      let allow = false;
      if(this.chain!=='main'){
        allow = await contract.methods.isApprovedForAll(this.wallet, environment.packManager).call()
      }
      //let allow = await contract.methods.isApprovedForAll(this.wallet, environment.packManager).call()
      //let eth = await this.getETH(walletSet);
      return {wallet:walletSet, allow:allow};
    }
    catch(err){
      console.log(err)
      return {error:true,message:err.message};
    }
  }

  async logout(){
    try {
      this.web3Modal.clearCachedProvider();
      localStorage.removeItem('code');
      return {};
    }
    catch(err){
      return {error:true,message:err.message};
    }
  }

  async checkApproval(){
    try{
      let contract = new this.web3.eth.Contract(yygabi, environment.yyg);
      let allow = await contract.methods.isApprovedForAll(this.wallet, environment.packManager).call()
      console.log(allow)
      if(!allow){
        let gas = await contract.methods.setApprovalForAll(environment.packManager, true).estimateGas({from: this.wallet});
        let limit = gas + 15000;
        let gasPrice = await this.web3.eth.getGasPrice();
        
        await contract.methods.setApprovalForAll(environment.packManager, true).send({from: this.wallet, gasLimit:limit, gasPrice:gasPrice})
        .on("transactionHash", async (hash) => {
          
          this.toast.info('Approval for YYG assets has started.');
        })
        .on("receipt", async(reciept) => {
          this.toast.success('Approval for YYG assets has completed.');
          allow=true;
         
        })
        .on("error", async(error)=>{
          console.log(error)
          this.toast.error(error.message);
     
        });

        
      }
      return allow;
    }
    catch(err){
      console.log(err);
    }
    

  }

  async burnNFT(signature, ids, season, userId){
    try{
      let contract = new this.web3.eth.Contract(packabi, environment.packManager);
      console.log(contract)
      //check allowance
      //let allow = await contract.methods.isApproved().call()

        let gas = await contract.methods.claimBurnPass(userId, season, ids, signature).estimateGas({from: this.wallet});
        let limit = gas + 15000;
        let gasPrice = await this.web3.eth.getGasPrice();
        
        let transfer = await contract.methods.claimBurnPass(userId, season, ids, signature).send({from: this.wallet, gasLimit:limit, gasPrice:gasPrice})
        .on("transactionHash", async (hash) => {
          
          this.toast.info('Burn of YYG has started.');
        })
        .on("receipt", async(reciept) => {
          this.toast.success('Burn of YYG has completed.');
         
        })
        .on("error", async(error)=>{
          this.toast.error(error.message);
     
        });


      return this.wallet;
      /*let gas = await contract.methods.transfer(environment.burn, formatedBurn).estimateGas({from: this.wallet});
    
      let limit = gas + 15000;
      let gasPrice = await this.web3.eth.getGasPrice();
      
      let transfer = await contract.methods.transfer(environment.burn, formatedBurn).send({from: this.wallet, gasLimit:limit, gasPrice:gasPrice})
      .on("transactionHash", async (hash) => {
        
        this.toast.info("Transaction has been started. Please wait for the transaction to be confirmed.");
      })
      .on("receipt", async(reciept) => {
        this.toast.success("Transaction has completed. Thank you for your purchase");
       
      })
      .on("error", async(error)=>{
        this.toast.error(error.message);
   
      });*/
    }
    catch(err){
      console.log(err);
    }
    

  }

  async packInteraction(sig, userId, type, amount){
    try{
      if(type==='ETH'){
        let contract = new this.web3.eth.Contract(packabi, environment.packManager);
        let ethPrice = await contract.methods.ETH_PRICE().call();
        let gas = await contract.methods.purchasePackETH(userId, amount, sig).estimateGas({from: this.wallet, value:ethPrice});
        let limit = gas + 15000;
        let gasPrice = await this.web3.eth.getGasPrice();
        let packBuy = await contract.methods.purchasePackETH(userId, amount, sig).send({from: this.wallet, value:ethPrice, gasLimit:limit, gasPrice:gasPrice})
        .on("transactionHash", async (hash) => {
          
          this.toast.info("Transaction has been started. Please wait for the transaction to be confirmed.");
        })
        .on("receipt", async(reciept) => {
          this.toast.success("Transaction has completed. Thank you for your purchase");
         
        })
        .on("error", async(error)=>{
          this.toast.error(error.message);
     
        });

      }
      else if(type=='SC'){
        let contract = new this.web3.eth.Contract(packabi, environment.packManager);
        let gas = await contract.methods.purchasePackSC(Number(userId), amount, sig).estimateGas({from: this.wallet});
        let limit = gas + 15000;
        let gasPrice = await this.web3.eth.getGasPrice();

        let packBuy = await contract.methods.purchasePackSC(Number(userId), Number(amount), sig).send({from: this.wallet, gasLimit:limit, gasPrice:gasPrice})
        .on("transactionHash", async (hash) => {
          
          this.toast.info("Transaction has been started. Please wait for the transaction to be confirmed.");
        })
        .on("receipt", async(reciept) => {
          this.toast.success("Transaction has completed. Thank you for your purchase");
         
        })
        .on("error", async(error)=>{
          this.toast.error(error.message);
     
        });
      }

      return this.wallet;
      
    }
    catch(err){
      console.log(err);
    }
    

  }


}
